const routes = [
    {
        path: "/lecturer/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "section_instructorlecturereportexcelexport"
        },
        component_full_path: 'lecturerReports/pages/Index'
    }
];

export default routes;
